import { CopyIdButton } from 'components/copy-id-button';
import { InlineValue } from './styles';
import { useIsExternalIdVisible } from './use-external-id.hook';

interface Props {
  orderNumber?: string;
  className?: string;
}

export const OrderNumberText = ({ orderNumber, className }: Props): JSX.Element | null => {
  const isVisible = useIsExternalIdVisible(orderNumber);

  if (!isVisible) {
    return null;
  }

  return (
    <InlineValue className={className} data-testid="order-number" data-cy="order-number">
      {orderNumber}
      <CopyIdButton value={orderNumber} />
    </InlineValue>
  );
};
